import { useState, useEffect } from 'react';

const useVisibleSection = (): string => {
    const [visibleSection, setVisibleSection] = useState('search');

    useEffect(() => {
        const ids = ['header', 'search', 'features', 'about', 'faq'];
        
        // Define rootMargin to track sections as they cross the center-ish area of the viewport
        const observerOptions = {
            root: null, // viewport
            rootMargin: '-30% 0px -30% 0px',
            threshold: 0,
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setVisibleSection(entry.target.id);
                }
            });
        }, observerOptions);

        ids.forEach(id => {
            const el = document.getElementById(id);
            if (el) {
                observer.observe(el);
            }
        });

        // Optimize edge cases: check scroll top/bottom boundaries
        const handleScroll = () => {
            const isAtTop = window.scrollY < 100;
            const isAtBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 100;

            if (isAtTop) {
                setVisibleSection('search');
            } else if (isAtBottom) {
                setVisibleSection('faq');
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        // Run once initially
        handleScroll();

        return () => {
            observer.disconnect();
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return visibleSection;
};

export default useVisibleSection;
